/* eslint-disable jira/filename-case */
export const JIRA_PORTFOLIO = 'JIRA_PORTFOLIO' as const;
export const JIRA_SERVICE_DESK = 'JIRA_SERVICE_DESK' as const;
export const JIRA_CUSTOMER_SERVICE = 'JIRA_CUSTOMER_SERVICE' as const;
export const JIRA_SOFTWARE = 'JIRA_SOFTWARE' as const;
export const JIRA_CORE = 'JIRA_CORE' as const;
export const JIRA_PRODUCT_DISCOVERY = 'JIRA_PRODUCT_DISCOVERY' as const;

type ProjectApplication =
	| 'JIRA_SERVICE_DESK'
	| 'JIRA_CUSTOMER_SERVICE'
	| 'JIRA_SOFTWARE'
	| 'JIRA_CORE'
	| 'JIRA_PRODUCT_DISCOVERY';

export type Application = ProjectApplication | 'JIRA_PORTFOLIO';

export type ProjectType =
	| 'business'
	| 'software'
	| 'service_desk'
	| 'product_discovery'
	| 'customer_service';

export const getApplicationForProject = (projectType: ProjectType): ProjectApplication => {
	switch (projectType) {
		case 'business':
			return JIRA_CORE;
		case 'product_discovery':
			return JIRA_PRODUCT_DISCOVERY;
		case 'software':
			return JIRA_SOFTWARE;
		case 'service_desk':
			return JIRA_SERVICE_DESK;
		case 'customer_service':
			return JIRA_CUSTOMER_SERVICE;
		default:
			throw new Error(`Unrecognised project type: ${projectType}`);
	}
};

// Jira Application Key type
export type JiraApplicationKey = ProjectApplication;

export const getApplicationKeyForProject = (projectType: ProjectType): JiraApplicationKey => {
	switch (projectType) {
		case 'business':
			return JIRA_CORE;
		case 'product_discovery':
			return JIRA_PRODUCT_DISCOVERY;
		case 'software':
			return JIRA_SOFTWARE;
		case 'service_desk':
			return JIRA_SERVICE_DESK;
		case 'customer_service':
			return JIRA_CUSTOMER_SERVICE;
		default:
			throw new Error(`Unrecognised project type: ${projectType}`);
	}
};
